import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Card from '/@/components/card';
import Form, { FormMessage } from '/@/components/form';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { changePassword } from '/@/store/session/actions';
import { getUser } from '/@/store/session/selectors';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import Input from '/@/v3/components/forms/input';
import styles from './styles.module.css';

@connect(
    (state) => ({ user: getUser(state) }),
    (dispatch) => bindActionCreators({ changePassword }, dispatch)
)
@autobind
export default class PasswordChange extends Form {
    static contextTypes = {
        history: PropTypes.object,
    };

    fields = {
        currentPassword: { initial: '' },
        password: { initial: '' },
        confirmPassword: { initial: '' },
    };

    validation = {
        password: (values) => values.password.length >= 4,
        confirmPassword: (values) => values.password === values.confirmPassword,
    };

    async handleSubmit() {
        this.setState({ loading: true, error: '' });
        try {
            await this.props.changePassword(this.state.values);
            this.context.history.goBack();
        } catch (error) {
            this.setState({ loading: false, error: error.message });
        }
    }

    render() {
        return (
            <div className={styles.root}>
                <Card>
                    <Input
                        iconPassword
                        type='password'
                        color={settings.app.theme}
                        placeholder={_('Contraseña actual')}
                        {...this.getFieldProps('currentPassword')}
                    />
                    <Input
                        iconPassword
                        type='password'
                        color={settings.app.theme}
                        placeholder={_('Nueva contraseña')}
                        {...this.getFieldProps('password')}
                    />
                    <Input
                        iconPassword
                        type='password'
                        color={settings.app.theme}
                        placeholder={_('Confirmar contraseña')}
                        {...this.getFieldProps('confirmPassword')}
                    />
                    <Stack direction='column' spacing={1}>
                        <Button
                            variant='contained'
                            disabled={this.state.loading || !this.validate()}
                            onClick={this.handleSubmit}
                        >
                            {this.state.loading ? _('Guardando...') : _('Guardar')}
                        </Button>
                        <Button
                            variant='outlined'
                            onClick={() => {
                                mpTrackEvent('Password change canceled', undefined);
                                this.context.history.goBack();
                            }}
                        >
                            {_('Cancelar')}
                        </Button>
                    </Stack>
                    <FormMessage style='error'>{this.state.error}</FormMessage>
                </Card>
            </div>
        );
    }
}
